document.addEventListener("DOMContentLoaded", init)
function init() {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach(container => {
        let config;
        try {
            config = JSON.parse(container.getAttribute('data-swiper-all')) || {};
        } catch (e) {
            console.error('Invalid JSON in data-swiper-all attribute', e);
            config = {};
        }
        const amountToShift = config.amountToShift !== undefined ? parseInt(config.amountToShift) : 0;
        const speed = config.speed !== undefined ? parseInt(config.speed) : 300;
        const slidesPerView = config.slidesPerView !== undefined ? parseFloat(config.slidesPerView) != 0 ? parseFloat(config.slidesPerView) : "auto" : "auto";
        const loopAdditionalSlides = config.loopAdditionalSlides !== undefined ? parseInt(config.loopAdditionalSlides) : 2;
        const spaceBetween = config.spaceBetween !== undefined ? parseInt(config.spaceBetween) : 0;
        const loop = config.loop !== undefined ? config.loop : false;
        const centeredSlides = config.centeredSlides !== undefined ? config.centeredSlides : false;
        const freeMode = config.freeMode !== undefined ? config.freeMode : false;

        const allowSlidePrev = config.allowSlidePrev !== undefined ? config.allowSlidePrev : false;
        const allowSlideNext = config.allowSlideNext !== undefined ? config.allowSlideNext : false;

        const breakpoints = config.breakpoints || {};
        const autoplay = (config.autoplay && Object.keys(config.autoplay).length > 0) ? config.autoplay : false;
        const pagination = container.querySelector('.swiper-pagination') || null;
        const navigationNext = container.querySelector('.swiper-button-next-custom') || null;
        const navigationPrev = container.querySelector('.swiper-button-prev-custom') || null;
        const swiper = new Swiper(container, {

            updateOnWindowResize: true,
            slidesPerView: 'auto',
            spaceBetween: spaceBetween,
            loop: loop,
            allowSlidePrev: allowSlidePrev,
            allowSlideNext: allowSlideNext,
            breakpoints: breakpoints,
            centeredSlides: centeredSlides,
            loopAdditionalSlides: loopAdditionalSlides,
            speed: speed,
            autoplay: autoplay,
            freeMode: {
                enabled: freeMode,
                momentumBounce: false,
            },
            pagination: pagination ? {
                el: pagination,
                clickable: true,
            } : false,
            navigation: {
                nextEl: navigationNext,
                prevEl: navigationPrev,
                disabledClass: 'disabled-arrow'
            },
            on: {
                init: function () {

                    adjustSlides(this, amountToShift);
                },
                slideChange: function () {

                },
                breakpoint: function () {
                    adjustSlides(this, amountToShift);


                },
                resize: function () {
                }
            },
        });
    });
}

function adjustSlides(swiper, amountToShift) {
    const totalSlides = swiper.params.slidesPerView;
    const slides = swiper.slides;
    slides.forEach((slide, index) => {
        if (amountToShift != 0) {
            slide.style.transform = `translateX(${amountToShift}%)`;
        }
        else if (amountToShift != 0) {
            slide.style.transform = "";
        }
    });
}